import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CeIconComponent } from '@enginuity/core/atoms/ce-icon/ce-icon.component';

@Component({
  standalone: true,
  selector: 'app-secondary-btns',
  templateUrl: './secondary-btns.component.html',
  styleUrls: ['./secondary-btns.component.scss'],
  imports: [CommonModule, CeIconComponent],
})
export class SecondaryBtnsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  @Input()
  active = false;

  @Input()
  disabled = false;

  @Input()
  label = 'Button';

  @Input()
  size: 'small' | 'medium' | 'large' = 'small';

  @Input()
  type: any = 'button';

  @Input()
  Type: any;

  @Input()
  IconValue = '';

  @Input()
  IconType: any = '';

  social_icons = ['google', 'facebook'];

  // @Input()
  // keyIcon: 'rightArrow' | 'leftArrow' | 'default' | 'leftArrow'='default';

  @Output() onClick = new EventEmitter<any>();
}
